export default __webpack_public_path__ + "static/media/default-logo.9a9ff69c.jpg";